module.exports = __webpack_public_path__ + "img/print-check-box-un-ticked-print.5bc8a9a9.svg";